import type { UserJSONObject } from '@ikegps/core-api';
import { CenteredCard } from '../../components/centered.card/centered.card';
import type { IMithrilComponent } from '../../components/mithril.component';
import type { MithrilVNode } from '../../mithril';
import { SSOLoginComponent } from '../../modules/auth/login';
import { Services } from '../../services/index';
import { IkePage, type IkePageConfig, IkePageName } from '../page';

export const LoginPageConfig: IkePageConfig = {
	type: 'internal',
	name: IkePageName.login,
	path: '/login',
	auth: { required: false },
	layout: { nav: false, banner: false },
};

export class LoginPage extends IkePage {
	name = 'Login';

	private redirectURL: string;
	private component: IMithrilComponent;

	constructor(redirectURL?: string) {
		super(LoginPageConfig);

		this.redirectURL = redirectURL || Services.Route.getRouteURL(IkePageName.map);

		this.component = new SSOLoginComponent();

		this.reaction(
			() => Services.User.current,
			(user) => this.checkLoggedIn(user),
			{ fireImmediately: true }
		);
	}

	get nodes(): MithrilVNode {
		return CenteredCard.view(this.component.view());
	}

	private enterSite() {
		Services.Route.goRaw(this.redirectURL);
	}

	private checkLoggedIn(user: UserJSONObject) {
		if (user != null) {
			this.enterSite();
		}
	}
}
